import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Default from "../../components/layouts/default";
import ClientService from "../../services/client.service";
import { setClient, setClientId } from "../../feature/client.slice";
import ScoreCard from "./ScoreCard";
import RecentThreads from "./RecentThreads";
import ListCard from "./ListCard";
import { fetchAllThreads } from "../../feature/chat.slice";
import chatService from "../../services/chat.service";

const Dashboard = () => {
  const dispatch = useDispatch();
  const client = localStorage.getItem("client");
  const clientIds = JSON.parse(client);
  const [userName, setUserName] = useState("");
  const [Threads, setThreads] = useState([]);
  const [files, setfiles] = useState([]);
  const [notDoneTask, setnotDoneTask] = useState("");
  const [unreadCount, setunreadCount] = useState("");
  const [TotalTask, setTotalTask] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
   const [dataLoading, setdataLoading] = useState(false);
  const fetchThreads = async () => {
    try {
      setdataLoading(true)
      const threads = await chatService.getdashboardstats();
      setThreads(threads.threads);
      setfiles(threads.recentFiles);
      setnotDoneTask(threads.pendingTask);
      setunreadCount(threads.unreadMessageCount);
      setTotalTask(threads.totalTask);
      if (threads.clientDetails && threads.clientDetails.length > 0) {
        dispatch(setClient(threads.clientDetails));
      }
    } catch (err) {
      setThreads([]);
      console.log(err);
    } finally {
    setdataLoading(false); 
  }
  };

  useEffect(() => {
    const storedUserName = localStorage.getItem("userName");
    setUserName(storedUserName);
    fetchThreads();
  }, [dispatch, client]);

  return (
    <Default
      className="dashboard"
      pageTitle={`Welcome Back, ${userName}`}
      pageSubTitle="Manage all your accounting needs seamlessly with the ADM ONE Portal, designed to simplify your financial workflow."
    >
      <div className="row">
        <div className="col-md-8 col-sm-12 mb-3 mb-md-0">
          <div className="scorecards_container mb-4">
            <ScoreCard
              title="Unread Chats"
              value={unreadCount || 0}
              textColor="text-dark"
              dataLoading={dataLoading}
            />

            <ScoreCard
              title="Pending Tasks"
              subtitle="Pending vs All"
              value={notDoneTask || 0}
              valueCompare={TotalTask}
              textColor="text-success"
              redirectPath="/tasks"
               dataLoading={dataLoading}
            />
          </div>

          <RecentThreads Threads={Threads || []}   dataLoading={dataLoading}/>
        </div>
        <div className="col-md-4 col-sm-12 ">
          <ListCard title="Recent Documents" files={files}  dataLoading={dataLoading} />
        </div>
      </div>
    </Default>
  );
};

export default Dashboard;
